module.exports = __webpack_public_path__ + "assets/img/card_ober.c4f1a7ba.jpg";